<template>
  <x-modal
    size="extra-large"
    data-test="upsell-modal"
    @overlay-clicked="$emit('close')"
  >
    <div class="x-modal__contents">
      <ys-text type="title3" class="title">
        See Beneath the Surface with 3D Lake Contours
      </ys-text>
      <ys-text type="body0-medium" class="body">
        Upgrade now to view lake bottom details in 3D and explore where fish
        might be hiding.
      </ys-text>
      <img :src="upsellImage" alt="3D Lake Contours Preview" />
    </div>
    <div class="x-modal__actions-vertical">
      <ys-button
        variant="primary"
        size="medium"
        data-test="3d-upgrade-now-button"
        @click="purchase"
      >
        Upgrade Now
      </ys-button>
      <ys-button
        variant="ghost"
        size="medium"
        data-test="close-button"
        @click.stop="$emit('close')"
      >
        Maybe Later
      </ys-button>
    </div>
  </x-modal>
</template>
<script setup lang="ts">
///// imports /////
import '@onxmaps/yellowstone-ui/ys-button'
import '@onxmaps/yellowstone-ui/ys-text'
import xModal from '@/components/shared/x-modal/index.vue'

import { goToPurchase } from '@/lib/purchase-utils'
import { PURCHASE_CTA_ORIGINS } from '@/lib/enums-marketing'
import upsellImage from '@/assets/images/fish/dimension-upsell.webp'

///// props/emits /////
defineEmits(['close'])

///// functions /////
const purchase = () => {
  goToPurchase({
    origin: PURCHASE_CTA_ORIGINS.ACCESS_3D_MAPS,
    detail: 'Upgrade',
  })
}
</script>
<style lang="scss" scoped>
@use '@/styles/system/_breakpoints.scss';

.x-modal__box .x-modal__actions-vertical {
  border-top: none;
  padding-top: 0;
  cursor: pointer;
}

.title,
.body {
  width: 80%;
  @include breakpoints.mobile {
    width: 100%;
  }
}

.title {
  margin-bottom: var(--ys-spacing-250);
}
.body {
  margin-bottom: var(--ys-spacing-150);
}
</style>
